const host = "https://www.sagishutrit.nl/images/drawings";
export const drawings = [

    {
        src: `${host}/roeland_atelier_bezoek_1.jpg`,
        title:'Portrait of a painter friend',
        year: '2026',
        medium: 'pencil & ink on bambo paper',
    },
    {
        src: `${host}/roeland_atelier_bezoek_2.jpg`,
        title:'Portrait of a painter friend',
        year: '2026',
        medium: 'pencil, ink & water colours on paper',
    },
    {
        src: `${host}/onpaper_study_presketch.jpg`,
        title:'study model & flower ',
        year: '2026',
        medium: 'pencil,papier',
        dimensions: '',
        ratio:'1.15'

    }, {
        
        src: `${host}/onpaper_study_for_stoeremeid.jpg`,
        title:'study model & flowers',
        year: '2026',
        medium: 'pencil,papier',
        dimensions: '',
        ratio:'1.15'
    
        
    },
        {
        src: 'https://www.sagishutrit.nl/images/drawings/jingens_indehood.jpg',
        title:'untitled',
        year: '2015',
        medium: 'pencil, ink & water colours on carton',
        dimensions: '',
        ratio:'1.15'  
    },
]

        
    // {
    //     src: 'https://www.sagishutrit.nl/images/gallery/hide_and_seek_2022.jpeg',
    //     title: '',
    //     year: '2000',
    //     medium: 'water colours on paper',
    //     dimensions: '',
    //     // width: '600px'
    // },
            // {
    //     src: 'https://www.sagishutrit.nl/images/gallery/flowers_HaagseSchool.jpg',
    //     title: '',
    //     year: '2021',
    //     medium: 'oil on wood',
    //     dimensions: '60 x 70 cm',
    //     width: '600px',
    //    // aspectRatio:'982/977'
    // },